import { store } from "../../..";
import { globalActions } from "../../../features/global/globalSlice";
import {
    leagueManagementActions,
    selectSelectedLeague,
} from "../../../features/leaguemgmt/leagueManagementSlice";

const createGameLeagueManagementLoader = async ({ params }: any) => {
    const leagueId = parseInt(params.leagueId);

    const settings = store.getState().global.settings;
    const fields = store.getState().global.fields;
    let league = selectSelectedLeague(store.getState());
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !fields.length && promises.push(store.dispatch(globalActions.getFields()));
    !league &&
        promises.push(store.dispatch(leagueManagementActions.getLeagues()));

    await Promise.all(promises);

    if (!league) {
        store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
        league = selectSelectedLeague(store.getState());
    }

    return {
        header: `Schedule ${league?.ageLevel}${league?.designation ? ` ${league?.designation}` : ""}${league?.direction ? ` ${league?.direction}` : ""} Game`,
    };
};

export default createGameLeagueManagementLoader;
